/**
 * Runtime configuration, read when the page loads rather than at build time.
 *
 * Create React App bakes process.env.REACT_APP_* into the bundle during
 * `npm run build`, so pointing a built image at a different backend used to
 * mean rebuilding it. The Docker image now writes /env-config.js at container
 * start from its environment variables (ReactJs/docker/40-runtime-env.sh):
 *
 *     window.__ENV__ = { "REACT_APP_BASE_URL": "http://10.0.0.5:5006" };
 *
 * index.html loads that file before the app, so the same image can serve the
 * test server and production with different backends.
 *
 * Precedence: runtime value (if the variable was set on the container, even to
 * an empty string) → build-time value → caller's fallback.
 *
 * The build-time value is passed in explicitly (process.env.REACT_APP_X
 * written out literally) because that is the form CRA reliably inlines.
 */
export function runtimeEnv(name, buildTimeValue) {
  if (typeof window !== "undefined" && window.__ENV__ && Object.prototype.hasOwnProperty.call(window.__ENV__, name)) {
    const value = window.__ENV__[name];
    if (value !== undefined && value !== null) return String(value);
  }
  return buildTimeValue;
}

export default runtimeEnv;
